import { FilterValueSelectComponent } from './components/filter-value-select/filter-value-select.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from "ngx-spinner";
import { ToastrModule } from 'ngx-toastr';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { SpinnerComponent } from './spinner/spinner.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { SessionTimeoutDialogComponent } from './session-timeout-dialog/session-timeout-dialog.component';
import { SpinnerService } from './spinner/spinner.service';
import { ToasterMessageService } from './toaster-message/toaster-message.service';
import { CommunicationService } from './communication/communication.service';
import { ConfirmationDialogService } from './confirmation-dialog/confirmation-dialog.service';
import { ShortLogoPipe } from './pipes/short-logo';
import { SupplierAvatarComponent } from './components/supplier-avatar/supplier-avatar.component';
import { ContactWebsiteComponent } from './components/contact-website/contact-website.component';
import { CustomModalComponent } from './components/custom-modal/custom-modal.component';
import { ExpenseModalComponent } from './components/expense-modal/expense-modal.component';
import { ManualCodingModalComponent } from './components/manual-coding-modal/manual-coding-modal.component';
import { SuggestedMatchesModalComponent } from './components/suggested-matches-modal/suggested-matches-modal.component';
import { FormatedDatePipe } from './pipes/formated-date.pipe';
import { SuggestedMatchCardComponent } from './components/suggested-match-card';
import { NgSelectModule } from '@ng-select/ng-select';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { SearchFilterToolbarComponent } from './components/search-filter-toolbar/search-filter-toolbar.component';
import { ColumnPickerComponent } from './components/column-picker/column-picker.component';
import { StatusPillComponent } from './components/status-pill/status-pill.component';
import { MainSearchComponent } from './components/main-search/MainSearch.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClickOutsideExceptDirective } from './directives/click-outside-except.directive';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TagPillComponent } from './components/tag-pill/tag-pill.component';
import { AiChatPanelComponent, MarkdownPipe } from './components/ai-chat-panel/ai-chat-panel.component';
import { ChatStatementComponent } from './components/ai-chat-panel/blocks/chat-statement.component';
import { VerificationBannerComponent } from './components/verification-banner/verification-banner.component';
import { VerificationRequiredModalComponent } from './components/verification-required-modal/verification-required-modal.component';
import { SelectableCardComponent } from './components/selectable-card/selectable-card.component';
import { TransactionDetailPanelComponent } from './components/transaction-detail-panel/transaction-detail-panel.component';
import { OnboardingChecklistCardComponent } from './components/onboarding-checklist-card/onboarding-checklist-card.component';
import { BillingUiModule } from './billing/billing-ui.module';
import { TransactionsTableComponent } from './components/transactions-table/transactions-table.component';
import { TransactionsSelectionBarComponent } from './components/transactions-table/transactions-selection-bar.component';
import { TransactionsFooterComponent } from './components/transactions-table/transactions-footer.component';
import { ListSkeletonComponent } from './components/list-skeleton/list-skeleton.component';
import { ColumnResizeDirective } from './directives/column-resize.directive';
import { OpenSupplierDirective } from './directives/open-supplier.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,    
    NgbModule,    
    NgxSpinnerModule,    
    ToastrModule.forRoot(),
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    MatNativeDateModule,
    NgSelectModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    BillingUiModule
  ],
  declarations: [
    SpinnerComponent,
    ConfirmationDialogComponent,
    SessionTimeoutDialogComponent,
    ShortLogoPipe,
    SupplierAvatarComponent,
    ContactWebsiteComponent,
    CustomModalComponent,
    ExpenseModalComponent,
    ManualCodingModalComponent,
    SuggestedMatchesModalComponent,
    SuggestedMatchCardComponent,
    FormatedDatePipe,
    SafeUrlPipe,
    SearchFilterToolbarComponent,
    ColumnPickerComponent,
    StatusPillComponent,
    MainSearchComponent,
    ClickOutsideExceptDirective,
    TagPillComponent,
    AiChatPanelComponent,
    ChatStatementComponent,
    MarkdownPipe,
    VerificationBannerComponent,
    VerificationRequiredModalComponent,
    SelectableCardComponent,
    OnboardingChecklistCardComponent,
    TransactionDetailPanelComponent,
    TransactionsTableComponent,
    ListSkeletonComponent,
    ColumnResizeDirective,
    OpenSupplierDirective,
    TransactionsSelectionBarComponent,
    TransactionsFooterComponent,
    FilterValueSelectComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,       
    ShortLogoPipe,
    SupplierAvatarComponent,
    ContactWebsiteComponent,
    SpinnerComponent,
    ConfirmationDialogComponent,
    CustomModalComponent,
    NgxSpinnerModule,
    ExpenseModalComponent,
    ManualCodingModalComponent,
    SuggestedMatchesModalComponent,
    SuggestedMatchCardComponent,
    FormatedDatePipe,
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    MatNativeDateModule,
    SafeUrlPipe,
    SearchFilterToolbarComponent,
    ColumnPickerComponent,
    StatusPillComponent,
    MainSearchComponent,
    ClickOutsideExceptDirective,
    TagPillComponent,
    AiChatPanelComponent,
    VerificationBannerComponent,
    VerificationRequiredModalComponent,
    SelectableCardComponent,
    OnboardingChecklistCardComponent,
    TransactionDetailPanelComponent,
    TransactionsTableComponent,
    ListSkeletonComponent,
    ColumnResizeDirective,
    OpenSupplierDirective,
    TransactionsSelectionBarComponent,
    TransactionsFooterComponent,
    FilterValueSelectComponent,
    // SD-1229: the Inbox Automator pill, and the upgrade / Inbox Automator modals.
    BillingUiModule
  ],
  providers: [
    SpinnerService,
    ToasterMessageService,
    CommunicationService,
    ConfirmationDialogService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CommonSharedModule {
  constructor() {    
  }
}
